import { JSX } from "react"
import { TableHeaderCol, TableRows } from "./models/tables"
import { combineAddress } from "../../../common/utils"
import { CdnUrl } from "../../../common/constants"
import { SortIcon } from "./icons";
import { localize } from "../../../common/services/localization";

export const Table: React.FC<{
    className?: string
    needSeparate?: boolean
    headClassName?: string
    bodyClassName?: string
    tableClassName?: string
    cols: TableHeaderCol[],
    rows: TableRows[],
}> = ({ cols, rows, className, tableClassName, headClassName, bodyClassName, needSeparate }) => {


    return (
        <div className={`${className}  text-[14px] md:text-[16px] lg:text-[20px] font-semibold`}>
            <table className={`table-fixed w-full ${needSeparate ? 'border-separate border-spacing-y-[6px]' : ''}  ${tableClassName}`}>
                <thead
                    className={`${headClassName ?? ''} h-[44px] shadow-[0px_0px_16px_0px_rgba(0,0,0,0.4)]`}
                    style={{
                        backgroundImage: 'url(' + combineAddress(CdnUrl, '/v2/images/ui/table-head.png') + ')',
                        backgroundColor: "#0E222E",
                    }}
                >
                    <tr className="">
                        {cols.map((col, i) => (
                            <th
                                key={i}
                                className={`py-2 whitespace-nowrap ${(col.sort || col.onSortChange) && 'cursor-pointer'} ${col.className}`}
                                onClick={() => {
                                    if (!col.sort) {
                                        col.onSortChange?.('asc');
                                    } else if (col.sort.direction === 'asc') {
                                        col.onSortChange?.('desc');
                                    } else {
                                        col.onSortChange?.('asc');
                                    }
                                }}
                            >
                                <div className="inline-flex items-center">
                                    <span className="mr-1">
                                        {col.headValue ? col.headValue : localize(col.headLocalName || '')}
                                    </span>
                                    {col.onSortChange && <SortIcon dir={col.sort?.direction} />}
                                </div>
                            </th>
                        ))}
                    </tr>

                </thead>
                <tbody className={bodyClassName}>
                    {rows.map((row, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className={`group ${row.className ?? ''} shadow-[0px_5px_8px_0px_rgba(0,0,0,0.42)]`}
                        >
                            {row.cols.map((col, colIndex) => {
                                const hasRedirect = row.href && (!col.disableHref)

                                return (
                                    <td
                                        key={colIndex}
                                        className={`py-[14px] bg-dark ${row.href ? 'group-hover:bg-[#0F212C]' : ''} ${hasRedirect ? ' cursor-pointer' : ''} ${col.className ?? ''}`}
                                        onClick={() => {
                                            if (hasRedirect)
                                                window.location.href = row.href!;
                                        }}
                                    >
                                        {col.value}
                                    </td>
                                );
                            })}
                        </tr>

                    ))}
                </tbody>
            </table>
        </div>
    );
};
